import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query';
import {
  createReferencedDocument,
  deleteInvoiceDocReferenced,
  getInvoiceDocReferencedId,
  listInvoiceDocReferenced,
  updateInvoiceDocReferenced,
} from './referencedDocument.service';
import { InvoiceDocReferencedPayload } from './referencedDocument.types';

export function useInvoicesReferencedDocument(id: number) {
  const query = useInfiniteQuery(
    ['docReferenced', id],
    () => listInvoiceDocReferenced(id),
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useCreateReferencedDocument() {
  const intl = useIntl();

  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: InvoiceDocReferencedPayload) => createReferencedDocument(obj),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'invoice.referencedDocument.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'invoice.referencedDocument.create.success.description',
          }),
        });

        queryClient.invalidateQueries(['docReferenced']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useDeleteInvoiceDocReferenced() {
  const intl = useIntl();

  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ invoiceId, id }: { invoiceId: number; id: number }) =>
      deleteInvoiceDocReferenced(invoiceId, id),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'invoice.referencedDocument.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'invoice.referencedDocument.delete.success.description',
          }),
        });

        queryClient.invalidateQueries(['docReferenced']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useGetInvoiceDocReferencedId() {
  const mutation = useMutation(
    ({ invoiceId, id }: { invoiceId: number; id: number }) =>
      getInvoiceDocReferencedId(invoiceId, id),
  );

  useServiceError(mutation.error);
  return mutation;
}

export function useUpdateInvoiceDocReferenced() {
  const intl = useIntl();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: InvoiceDocReferencedPayload) => updateInvoiceDocReferenced(obj),
    {
      onSuccess() {
        notification.success({
          message: intl.formatMessage({
            id: 'invoice.referencedDocument.create.success.title',
          }),
          description: intl.formatMessage({
            id: 'invoice.referencedDocument.update.success.description',
          }),
        });

        queryClient.invalidateQueries(['docReferenced']);
      },
    },
  );

  useServiceError(mutation.error);
  return mutation;
}
